import axios from 'axios'
import _ from 'lodash'
import yn from 'yn'

import { clientIds } from '../configuration/brand'
import { formatTours } from '../utilities/content/tours'

const DolliHTTP = axios.create({
  header: { Accept: 'application/ld+json' },
  params: process.env.REACT_APP_ENABLE_DOLLI_CACHE_BUSTING && yn(process.env.REACT_APP_ENABLE_DOLLI_CACHE_BUSTING)
    ? { provider: 1, cache: new Date().getTime() }
    : { provider: 1 },
})

const endpoints = {
  destinations: process.env.REACT_APP_ENDPOINT_DOLLI + '/content/destinations',
  tours: process.env.REACT_APP_ENDPOINT_DOLLI + '/tour/products',
}

export const tours = (brand) => {
  const clientId = clientIds[brand]
  return Promise.all([
    DolliHTTP.get(endpoints.tours, {params: {brand, clientId}}),
    DolliHTTP.get(endpoints.destinations, {params: {brand, clientId}}),
  ])
    .then(responses => {
      return formatTours(
        _.get(responses, '[0].data.hydra:member', []),
        _.get(responses, '[1].data.hydra:member', [])
      )
    })
}

export default endpoints
